import rgbHex from 'rgb-hex'
import colors from '../../../config/colors.json'

function getXPProgress(totalXP, xpRequired) {
	let levelRequirements = [xpRequired]

	for (let i = 0; i < levelRequirements.length; i++) {
		if (totalXP < levelRequirements[i]) {
			const prevReq = i === 0 ? 0 : levelRequirements[i - 1]
			const nextReq = levelRequirements[i]
			return ((totalXP - prevReq) / (nextReq - prevReq)) * 100
		}
	}
	// If XP exceeds last requirement = max level
	return -1
}

export function KarmaDisplay({ current, max, color, isActive, progress }) {
	//jeannes xp is just an integer an has no limits
	//all the level ups are just statemodel bools

	let mainColor = rgbHex(colors[color]?.mainColor)
	let icon = '/liveGameIcons/unique/jin/karma.png'

	// while active, the bar shows remaining ability duration instead of karma
	const fill = isActive ? Math.min(Math.max(1 - (progress ?? 0), 0), 1) * 100 : getXPProgress(current, max)

	return (
		<div
			className={`border-solid border flex flex-col justify-center w-[84px] h-[40px] ${isActive ? 'karma-shine' : ''}`}
			style={{
				borderColor: 'var(--main-color)',
				backgroundImage: isActive ? undefined : 'url("/sheepCounter/background.png")',
			}}>
			<div className="flex flex-row w-[82px] justify-center">
				<img src={icon} className="w-[33px] h-[33px]" alt="" />
			</div>
			<div className="w-[82px] h-[8px] flex flex-row border-solid border" style={{ borderColor: isActive ? '#6B4F1D' : '#5E6989' }}>
				<div
					className={isActive && fill < 20 ? 'karma-timer-low' : ''}
					style={{
						background: isActive ? 'linear-gradient(180deg, #FFF4CC 0%, #F3DA8C 50%, #D9B45A 100%)' : `#${mainColor}`,
						boxShadow: isActive ? '1px 0 3px rgba(255, 244, 204, 0.9)' : undefined,
						flexBasis: `${fill}%`,
						transition: isActive ? 'flex-basis 0.5s linear' : undefined,
					}}></div>
				<div
					style={{
						backgroundColor: isActive ? '#3A2A0C' : '#000000',
						flexBasis: `${100 - fill}%`,
						transition: isActive ? 'flex-basis 0.5s linear' : undefined,
					}}></div>
			</div>
		</div>
	)
}
